export default "__VITE_ASSET__C3f9QhRI__"